import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  checkIsTeacherAssociatedWithStudentQuery,
  getCourseAllStudentQuery,
  getStudentPypElementRatingsQuery,
  getStudentSubjectsQuery,
  getTeacherCoursesStudentsQuery,
} from "./StudentPortfolioQuery";

export const getCourseAllStudentsFromCache = args => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseAllStudentQuery,
      variables: args,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentPypElementRatingsFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentPypElementRatingsQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentSubjectsFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentSubjectsQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  return queryData;
};

export const getTeacherCoursesStudentsQueryFromCache = params => {
  try {
    const queryData = client.readQuery({
      query: getTeacherCoursesStudentsQuery,
      variables: params,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getIsTeacherAssociatedWithStudentFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: checkIsTeacherAssociatedWithStudentQuery,
      variables,
    });

    const teacherStudentAssociationData = _.get(
      queryData,
      "platform.isTeacherAssociatedWithStudent",
      []
    );

    return { teacherStudentAssociationData };
  } catch (e) {
    return {};
  }
};
